<template lang="pug">

  div
    h2 Support page
    div( class="row")
      div( class="col-sm-3")
      div( class="col-sm-6" )
        h2 Ask Moonpull a question
        p( v-if="messageSent" )
          | Your Message has Sent
          br
          button( class="btn btn-primary" v-on:click="messageSent = false" ) Send another message
        MForm(v-else v-on:submit="sendMail")
          MInput(
            name="name"
            label="Name"
            type="text"
            v-bind:value="(this.$moonpull.getCurrentUserSession().name)"
          )
          MInput(
            name="useremail"
            label="Email"
            type="text"
            v-bind:value="(this.$moonpull.getCurrentUserSession().email)"
          )
          MInput(
            name="company"
            label="Company"
            type="text"
            v-bind:value="(this.$moonpull.getCurrentUserSession().company.name)"
          )
          MInput(
            name="text"
            label="Message:"
            type="textarea"
            required
          )
    
    hr
    div( class="row" )
      div( class="col-lg-3" )
      div( class="col-lg-6" )
        h2 Moonpull use Freshdesk as our Knowledge Base partner.

        div() 
          p Moonpull users also need a Freshdesk account to access help material using the same email address as used for their Moonpull account.

          p If you haven’t signed up already, you can 
            a( href="https://moonpull.freshdesk.com/support/signup" target="_blank" ) sign up here 

          p If your browser is already logged into Freshdesk you will not need to log in again.
 
        h2 Moonpull knowledge base - all clients

        div()
          p As explained above you need to be logged into Freshdesk to access articles. 

        ul( class="mt-4")

          p
            a( href="https://moonpull.freshdesk.com/support/solutions" target="_blank" ) Knowledge Base home page
          p
            a( href="https://moonpull.freshdesk.com/support/solutions/folders/101000376022" target="_blank" ) Getting Started
            
          p
              a( href="https://moonpull.freshdesk.com/support/solutions/folders/101000376021" target="_blank" ) FAQs and User Articles


</template>
<style scoped></style>
<script>
import Vue from "vue";
import gql from "graphql-tag";
export default Vue.extend({
  data() {
    return {
      messageSent: false,
    };
  },

  methods: {
    async sendMail(data) {
      await this.$apollo.query({
        query: gql`
          query(
            $email: String!
            $message: String!
            $name: String!
            $company: String!
            $useremail: String!
          ) {
            supportQuery(
              email: $email
              message: $message
              name: $name
              company: $company
              useremail: $useremail
            )
          }
        `,
        variables: {
          email: this.$moonpull.getCurrentUserSession().email,
          message: data.text,
          name: data.name,
          useremail: data.useremail,
          company: data.company,
        },
      }),
        (this.messageSent = true);
    },
  },
});
</script>
